"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseBodyFrame = exports.parseStatus = exports.frameRequest = exports.GrpcWebFrame = exports.HEADER_SIZE = void 0;
const index_1 = require("./index");
const grpc_status_code_1 = require("./grpc-status-code");
exports.HEADER_SIZE = 5;
var GrpcWebFrame;
(function (GrpcWebFrame) {
    GrpcWebFrame[GrpcWebFrame["DATA"] = 0] = "DATA";
    GrpcWebFrame[GrpcWebFrame["TRAILER"] = 128] = "TRAILER";
})(GrpcWebFrame = exports.GrpcWebFrame || (exports.GrpcWebFrame = {}));
function frameRequest(protobuf) {
    let len = protobuf.length;
    let body = new Uint8Array(exports.HEADER_SIZE + len);
    body[0] = GrpcWebFrame.DATA;
    body[1] = (len >> 24) & 0xff;
    body[2] = (len >> 16) & 0xff;
    body[3] = (len >> 8) & 0xff;
    body[4] = len & 0xff;
    body.set(protobuf, 5);
    return body;
}
exports.frameRequest = frameRequest;
function parseStatus(headers) {
    let s = headers['grpc-status'];
    let code = s ? parseInt(s, 10) : undefined;
    return [code, headers['grpc-message']];
}
exports.parseStatus = parseStatus;
function parseBodyFrame(bodyBs) {
    if (bodyBs.length === 0) {
        return [bodyBs];
    }
    if (bodyBs[0] == GrpcWebFrame.DATA) {
        let msgLen = 0;
        for (let i = 1; i < exports.HEADER_SIZE; i++)
            msgLen = (msgLen << 8) + bodyBs[i];
        var trunkIndex = exports.HEADER_SIZE + msgLen;
        if (bodyBs.length >= trunkIndex) {
            var dataTrunk = bodyBs.subarray(exports.HEADER_SIZE, trunkIndex);
            if (bodyBs.length > (trunkIndex += exports.HEADER_SIZE)) {
                return [dataTrunk, index_1.OutputProto.textDecode(bodyBs.subarray(trunkIndex))];
            }
            return [dataTrunk];
        }
    }
    throw new index_1.RpcError(grpc_status_code_1.GrpcStatusCode.DATA_LOSS, 'not support trunk with magic: ' + bodyBs[0]);
}
exports.parseBodyFrame = parseBodyFrame;
